const StoreHours = ({ storeHours }: { storeHours: string }) => {
  return (
    <div
      className="[&_.medium-3>div>b]:inline-block [&_.medium-3>div>b]:w-10 [&_.medium-3>div]:flex [&_.medium-3>div]:items-baseline [&_.medium-3>div]:gap-1 [&_.medium-3>div]:text-sm [&_.medium-3>div]:text-gray-800"
      dangerouslySetInnerHTML={{
        __html: storeHours,
      }}
    />
  );
};

export default StoreHours;
